import React from "react";
import { createRoot } from "react-dom/client";
import OperatorContactData from "./OperatorContactData";
import { testimonialsType } from "../../common/types/product";

declare global {
	interface Window {
		renderOperatorContactData: unknown;
	}
}

export function renderOperatorContactData(
	rootId: string,
	title: string,
	subscribeLink: string,
	testimonials: testimonialsType,
) {
	const root = createRoot(document.getElementById(rootId)!);
	root.render(
		<OperatorContactData
			packageName={title}
			subscribeLink={subscribeLink}
			testimonials={testimonials}
		/>,
	);
}

window.renderOperatorContactData = renderOperatorContactData;
